import { print } from 'graphql';
import gql from 'graphql-tag';
import type { RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { rootStore } from '../../mobx-models/Root';
import { BaseEntity } from '../../models/BaseEntity';
import { SYNC_LIMIT_LOW } from '../../utilities/constants';
import defaultDoc from '../Shared/defaultDoc';

export interface ServiceStatus extends BaseEntity {
  description: string;
}
export type ServiceStatusCollection = RxCollection<ServiceStatus> | null;
export type ServiceStatusDocument = RxDocument<ServiceStatus>;

export const serviceStatusSchema: RxJsonSchema<ServiceStatus> = {
  type: 'object',
  version: 0,
  description: 'describes a serviceStatus object',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    updatedAt: { type: 'number' },
    isDeleted: { type: 'boolean' },
    version: { type: 'number' },
    description: { type: 'string' },
  },
};

export const serviceStatusPullQueryBuilder = (doc: ServiceStatus) => {
  if (!doc) {
    doc = { ...defaultDoc, updatedAt: 0 };
  }

  const query = print(gql`
    query serviceStatusFeed($siteId: ID!, $lastUpdateAt: Float!, $limit: Int!) {
      serviceStatusFeed(siteId: $siteId, lastUpdateAt: $lastUpdateAt, limit: $limit) {
        description
        id
        isDeleted
        updatedAt
        version
      }
    }
  `);

  return {
    query,
    variables: {
      siteId: rootStore.user.siteId,
      lastUpdateAt: doc.updatedAt,
      limit: SYNC_LIMIT_LOW,
    },
  };
};

export default {};
